export default __webpack_public_path__ + "static/media/heat.c3ba63d6.png";